/**
 * This object is also used to determine which layers are active for the
 * scheduling flow.
 */
export var SchedulingFilter;
(function (SchedulingFilter) {
    SchedulingFilter["DROP_OFF"] = "dropOff";
    /**
     * If enabled, we find eligible nurses on timeslots. Not added during nurse
     * rescheduling.
     */
    SchedulingFilter["NURSE"] = "nurse";
    SchedulingFilter["MOBILE_COLLECTION"] = "mobileCollection";
    SchedulingFilter["SITE_COLLECTION"] = "siteCollection";
    /**
     * If CareSend is responsible for shipping supplies to the patient or having
     * a nurse use their own supplies.
     */
    SchedulingFilter["SUPPLIES_SHIPPED_BY_CARESEND"] = "suppliesShippedByCareSend";
    /**
     * If an office is sending supplies directly to the patient.
     */
    SchedulingFilter["SUPPLIES_SHIPPED_BY_OFFICE"] = "suppliesShippedByOffice";
    /**
     * @deprecated
     * Use `SUPPLIES_SHIPPED_BY_CARESEND` instead. We are keeping this to retain
     * backwards compatibility.
     */
    SchedulingFilter["SUPPLY"] = "supply";
})(SchedulingFilter || (SchedulingFilter = {}));
//# sourceMappingURL=scheduling.js.map